import { render, staticRenderFns } from "./MatchLeaderboard.vue?vue&type=template&id=c438761e"
import script from "./MatchLeaderboard.vue?vue&type=script&lang=js"
export * from "./MatchLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports